'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlankItem = function (_React$Component) {
  _inherits(BlankItem, _React$Component);

  function BlankItem(props) {
    _classCallCheck(this, BlankItem);

    var _this = _possibleConstructorReturn(this, (BlankItem.__proto__ || Object.getPrototypeOf(BlankItem)).call(this, props));

    _this.fixMe = _this.fixMe.bind(_this);
    _this.getBlankStyle = _this.getBlankStyle.bind(_this);
    return _this;
  }

  _createClass(BlankItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fixMe();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.fixMe();
    }
  }, {
    key: 'fixMe',
    value: function fixMe() {
      var di = _reactDom2.default.findDOMNode(this);
      if (di !== null) {
        this.props.fixH(di);
      }
    }
  }, {
    key: 'getBlankStyle',
    value: function getBlankStyle() {
      var myStyle = {
        filter: 'greyscale(100%)',
        opacity: '0.3',
        transform: 'translate(0px,' + this.props.trans + 'px)',
        WebkitTransform: 'translate(0px,' + this.props.trans + 'px)',
        pointerEvents: 'none',
        touchAction: 'none'
      };
      return myStyle;
    }
  }, {
    key: 'render',
    value: function render() {
      var _style = _extends({}, this.props.children.props.style, this.getBlankStyle());
      return _react2.default.cloneElement(this.props.children, { style: _style, className: typeof this.props.class === 'undefined' ? '' : this.props.class });
    }
  }]);

  return BlankItem;
}(_react2.default.Component);

exports.default = BlankItem;


BlankItem.PropTypes = {
  trans: _propTypes2.default.number.isRequired,
  fixH: _propTypes2.default.func.isRequired,
  class: _propTypes2.default.string
};

BlankItem.defaultProps = {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/drag-drop-list-react/dist/BlankItem.js
// module id = 184
// module chunks = 0